import { styled } from '@mui/material/styles';
import Card from './Card';

const VolunteerCard = styled(Card)({
    fontSize: '0.8rem'
});

export default VolunteerCard;